<!--
     <FilterDatesRange
       :filters="QFilters"
       @update="handle_update(QFilters)"
     />
-->

<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    min-width="290px"
    dense
  >

    <template v-slot:activator="{ on, attrs }">
      <div>
        <v-text-field
          v-if="!is_mobile"
          :value="dateRangeText"
          :placeholder="$vuetify.lang.translator('filters.dates.date_range')"
          readonly
          v-bind="attrs"
          v-on="on"
          solo
          flat
          clearable
          dense
          filled
          hide-details	
          :rules="[validate_visit_date]"
          :class="props.activator_class ? props.activator_class : 'component explorer-table-searchable-text'"
          background-color="#f2f2f2"
          @click:clear="closePicker"
        >
          <v-icon
            slot="append"
            class="icon-large explorer-table-searchable-icon"
          >
            mdi-calendar
          </v-icon>
        </v-text-field>
        <v-btn
          v-else
          v-bind="attrs"
          v-on="on"
          @click:clear="closePicker"
          icon
          small
        >
          <v-icon small>mdi-calendar-question</v-icon>
        </v-btn>
      </div>
    </template>

    <v-card>
      <v-card-text>
        <v-autocomplete
          v-model="selected"
          :items="date_fields"
          :label="$vuetify.lang.translator('filters.dates.date_field')"
          :multiple="false"
          item-text="name"
          item-value="id"
          dense
          :clearable="true"
          deletable-chips
          :disabled="false"
          :full-width="true"
          outlined
          small-chips
          return-object
          :search-input.sync="search_text"
          persistent-hint	
          >
            <template v-slot:selection="data">
              <!-- selected will be multiple, an array, meanwhile it's a single selector, 
                so we make it an array so the condition is not changed -->
              <v-chip 
                v-if="!search_text && [selected].length < 4"
                small
                color="primary"
              >
                {{ data.item.name }}
              </v-chip>
              <div
                v-else-if="!search_text && data.index === 0"
                class="qmkey-generic-process-filter-selection-text"
              >
                {{ `${selected.length} Fechas seleccionadas` }}
              </div>
            </template>
        </v-autocomplete>
        <v-date-picker 
          v-model="dates"
          range
          no-title
          first-day-of-week="1"
          color="primary"
          :locale="$vuetify.lang.current"
        ></v-date-picker>
      </v-card-text>
      <v-card-actions class="qmkey-modal-dialog-card-actions">
        <v-spacer></v-spacer>
        <v-btn 
          class="qmkey-modal-dialog-button-secundary"
          text 
          color="primary" 
          @click="closePicker"
          small
        >
          {{ $vuetify.lang.translator('dialog.clear') }}
        </v-btn>
        <v-btn 
          class="qmkey-modal-dialog-button-submit"
          @click="setFilterDates"
          small
          :disabled="!range_valid"
        >
          {{ $vuetify.lang.translator('dialog.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-menu>
</template>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>


<script>
 import { mapGetters } from 'vuex'
 import QUnit from '@/api/QUnit';
 import { diferences_between_arrays } from '@/utils/logic';
 import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   name: 'FilterDatesRange',

   props: {
     'filters': {},
     'is_mobile': {},
     'props': {default: () => ({})},
    },

   data: () => ({
     dates: [],
     menu: false,
     range_valid: true,
     selected: [],
     search_text: '',
     date_fields: [],
   }),

   computed: {
     ...mapGetters(['sitePath', 'centro_id']),

     business_process() {
       return this.filters.get_filter_value('business_process');
     },

     dateRangeText() {
       function date2text(dt) {
         return new Date(dt).toLocaleDateString(undefined, {
           // weekday: 'long',
           year: 'numeric',
           month: 'numeric',
           day: 'numeric',
         });
       }

       return (this.dates||[]).map(date2text).join(' ~ ');
     },
   },

  mounted() {
    this.pull_filters(); // sincronize local dates
   },

   methods: {
     pull_filters() {
       if (diferences_between_arrays(this.dates||[], (this.filters.get_filter_value('filter_dates') || {}).range||[]).length > 0
           || (this.selected||{id: -1}).id != (this.filters.get_filter_value('filter_dates') || {}).field) {
         // Pull this.dates
         this.dates = (this.filters.get_filter_value('filter_dates')||{}).range||this.filters.get_filter_value('date_range')||[];
       }
       this.setDatesFields();
     },

     validate_visit_date(v) {
      // TODO: Show somewhere error message
      // this.$vuetify.lang.translator('filters.dates.date1_lower')
      
      if (this.dates.length != 2){
        this.range_valid = false;
      }
      else if (this.dates[1] < this.dates[0]){
        this.range_valid = false;
      }else {
        this.range_valid = true;
      }
      return this.range_valid;
     },

     emit_update() {
      // Selected should be always set, so this is not necessary but we do it
      // anyway just in case.
       const date_filters = {
        range: this.dates,
        field: 'current_workflow_limit',
       } 
       if (this.selected && this.selected.id) {
        date_filters["field"] = this.selected.id;
       }
       let filters = new QFilters();
       filters.set_filter(get_qfilter('filter_dates',date_filters));
       this.$emit("update", filters);
     },

     setFilterDates(evt) {
       if (this.dates || this.dates.length) {
         if (this.dates[1] >= this.dates[0]) {
           this.$refs.menu.save(this.dates);
           this.emit_update();
         }
         this.menu = false;
       }
     },

     closePicker(evt) {
       let fire_update = (this.dates.length == 2);
       this.$refs.menu.save([]);
       this.dates = [];
       this.selected = [];
       this.search_text = ''
       this.menu = false;
       if (fire_update)
           this.emit_update();
     },

     async setDatesFields() {
       // Don't worry, the API call is cached on the frontend ;-)
       const data = await QUnit.getFieldsByTypeToCollectForFiltering(
         this.centro_id,
         this.business_process
       );
       this.date_fields = data.fields;
       // Get filter field id or default
       const field = (this.filters.get_filter_value('filter_dates')||{}).field || this.filters.get_filter_value('filter_dates') || "current_workflow_limit";
       this.selected = this.date_fields.filter(x => x.id == field)[0] || null;
     },

     get_value() {
        let res = new QFilters();
        const date_filters = {
          range: this.dates,
          field: 'current_workflow_limit',
        } 
        if (this.selected && this.selected.id) {
          date_filters["field"] = this.selected.id;
        }
        res.set_filter(get_qfilter('filter_dates',date_filters));
        return res;
      },
   },

   watch: {
     filters() {
       this.pull_filters();
     },
     business_process() {
      this.pull_filters();
     },
   },
 }
</script>
